(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OrdineDetailController', OrdineDetailController);

    OrdineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Ordine', 'Documento', 'Dichiarazione', 'DettaglioOrdine', 'DocumentoFile'];

    function OrdineDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Ordine, Documento, Dichiarazione, DettaglioOrdine, DocumentoFile) {
        var vm = this;

        vm.ordine = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.openStorageFile = openStorageFile;

        function openStorageFile (documento) {
        	var	type = documento.fileContentType;
        	var data = documento.file;
        	
        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        function onGetFileError () {
        	modalScrollTop();
        };	

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
	     			vm.ordine.documentoPdf["file"]=result.file;
	            });
        }

        var unsubscribe = $rootScope.$on('ordiniApp:ordineUpdate', function(event, result) {
            vm.ordine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
